export const environment = {
    production: false,
    BASE_URL: `https://test-api.tybu.tdex.in`,
    IMAGE_URL: `https://axivise-images.s3.ap-south-1.amazonaws.com/app/`,
};